import React from "react";
import { PageContainer, Content, Header } from "../Drawer/PageContainer";
import { MsalContext } from "@azure/msal-react";
import { getCompressedJson, getRawJson } from "../../API/Export/ExportApi";
import { getAzureUser } from "../../API/User/User";
import { getProject } from "../../API/Project/project";

export class ExportContent extends React.Component {

    static contextType = MsalContext;

    constructor(props) {
        super(props);
        this.state = {
            data: {
                ProjectName: "",
                ProjectId: "",
            },
            len: 0,
            call: 0,
        };
    }

    getJson = async (InstanceType, forImport) => {
        const { context } = this;
        let user = await getAzureUser(context);
        const userId = user.oid

        const project = await getProject(this.props.projectId);

        const instance = project.instances.find(
            (instance) => instance.instanceType === InstanceType
        );

        const [json, compressedJson] = await Promise.all([
            getRawJson(
                this.props.projectId,
                this.props.organisationId,
                userId,
                instance._id,
                InstanceType === "Preview",
                forImport
            ),
            getCompressedJson(
                this.props.projectId,
                this.props.organisationId,
                userId,
                instance._id,
                InstanceType === "Preview",
                forImport
            ),
        ]);
        const a = document.createElement("a");
        const blob = new Blob([JSON.stringify(json)], {
            type: "application/json",
        });
        a.href = URL.createObjectURL(blob);
        a.download =
            "Designer_" +
            json.ProjectLabel.replace(/\s/g, "_") +
            "-" +
            json.ProjectId +
            ".json";
        a.click();

        const an = document.createElement("a");
        an.href = URL.createObjectURL(compressedJson);
        an.download =
            "Designer_" +
            json.ProjectLabel.replace(/\s/g, "_") +
            "-" +
            json.ProjectId +
            ".gz";
        an.click();
    };

    render() {
        return (
            <PageContainer>
                <Header
                    header="Export App Schema"
                    headerDescription="Export you app schema and use for your reference or use it to import app again"
                >
                </Header>
                <Content>
                    <div className="m-4">
                        <div className="mb-4">
                            <h6>Export for App Workspace</h6>
                            <button
                                className="btn btn-primary"
                                onClick={() => this.getJson("Preview", false)}
                            >
                                Preview Data
                            </button>
                            <button
                                className="btn btn-primary ms-2"
                                onClick={() =>
                                    this.getJson("Production", false)
                                }
                            >
                                Publish Data
                            </button>
                        </div>
                        <div className="my-2">
                            <h6>Export for Import</h6>
                            <button
                                className="btn btn-primary"
                                onClick={() => this.getJson("Preview", true)}
                            >
                                Preview Data
                            </button>
                            <button
                                className="btn btn-primary ms-2"
                                onClick={() =>
                                    this.getJson("Production", true)
                                }
                            >
                                Publish Data
                            </button>
                        </div>
                    </div>
                </Content>
            </PageContainer>
        )
    }
}
